import React from "react";
import CameraPage from './CameraPage'

const SearchPage = () => {
    return <div><CameraPage></CameraPage></div>
}

export default SearchPage;